import { useJson } from '@/hooks/useJson'

export interface CoverageClass {
  title: string
  discipline: string
  instructor: string | null
  aired_on: string // YYYY-MM-DD
}

export interface CoverageDiscipline {
  key: string
  classes: number
  first_aired: string
  last_aired: string
}

export interface CoverageYear {
  year: number
  total: number
  by_discipline: Record<string, number>
}

export interface CatalogCoverage {
  total_classes: number
  with_playlists: number
  oldest: CoverageClass | null
  newest: CoverageClass | null
  disciplines: CoverageDiscipline[]
  years: CoverageYear[]
}

export function useCatalogCoverage() {
  return useJson<CatalogCoverage>('/api/catalog_coverage', 'Failed to load coverage')
}
